import { render } from "./MainTable.vue?vue&type=template&id=1b7707f2&scoped=true"
import script from "./MainTable.vue?vue&type=script&lang=js"
export * from "./MainTable.vue?vue&type=script&lang=js"

import "./MainTable.vue?vue&type=style&index=0&id=1b7707f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7707f2"]])

export default __exports__